export default __webpack_public_path__ + "static/media/Swadhey.f0f9243a.png";